import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackItemSavedItemPage = () => useTrackConversion({ goal: KameleoonGoalData.SavedItemItemPage });
